export const STORAGE_KEYS = {
  data: 'NORSK_USER_DATA',
  colors: 'NORSK_USER_COLORS',
  categoryMeta: 'NORSK_CATEGORY_META',
  categoryOrder: 'NORSK_CATEGORY_ORDER',
  constructorGroups: 'NORSK_CONSTRUCTOR_GROUPS',
  analysisLibrary: 'NORSK_ANALYSIS_LIBRARY',
  learningProgress: 'NORSK_LEARNING_PROGRESS',
  deckSubcategories: 'NORSK_DECK_SUBCATEGORIES',
  analyzerAliases: 'NORSK_ANALYZER_ALIASES',
  userProfile: 'NORSK_USER_PROFILE',
  userRegistry: 'NORSK_USER_REGISTRY',
  hiddenSkeleton: 'NORSK_HIDDEN_SKELETON',
  pendingRegistration: 'NORSK_PENDING_REGISTRATION',
};

export const grammarIconCatalog = {
  'Предлог': {
    'Указательный': [
      {
        id: 'PU01',
        symbol: '👉',
        label: 'указательный палец вправо',
      },
    ],
    'Местонахождение': [
      {
        id: 'PM01',
        symbol: '👇',
        label: 'указательный палец вниз',
      },
    ],
    'Принадлежность': [
      {
        id: 'PP01',
        symbol: '🔗',
        label: 'принадлежность или связь',
      },
    ],
  },
};

export const grammarIconParts = [
  'Существительное',
  'Глагол',
  'Прилагательное',
  'Предлог',
  'Местоимение',
  'Наречие',
  'Союз',
  'Частица',
  'Междометие',
  'Числительное',
];

export const LEGACY_DATA_KEYS = ['norsk-db-v5', 'norsk-db-v4', 'norsk-db'];

export const fallbackDb = {
  Pronomen: {
    Personlige: [
      { text: 'jeg', lvl: 'A1' },
      { text: 'du', lvl: 'A1' },
      { text: 'han', lvl: 'A1' },
      { text: 'hun', lvl: 'A1' },
      { text: 'vi', lvl: 'A1' },
    ],
  },
  Substantiv: {
    Personer: [
      {
        text: 'student',
        lvl: 'A1',
        type: 'noun',
        forms: {
          singularDefinite: 'studenten',
          pluralIndefinite: 'studenter',
          pluralDefinite: 'studentene',
        },
        translations: [],
        synonyms: [],
        antonyms: [],
      },
      {
        text: 'lærer',
        lvl: 'A1',
        type: 'noun',
        forms: {
          singularDefinite: 'læreren',
          pluralIndefinite: 'lærere',
          pluralDefinite: 'lærerne',
        },
        translations: [],
        synonyms: [],
        antonyms: [],
      },
    ],
  },
  Verb: {
    Handling: [
      {
        text: 'komme',
        lvl: 'A1',
        type: 'verb',
        forms: {
          present: 'kommer',
          past: 'kom',
          perfect: 'kommet',
          imperative: 'kom',
        },
        translations: [],
        synonyms: [],
        antonyms: [],
      },
      {
        text: 'snakke',
        lvl: 'A1',
        type: 'verb',
        forms: {
          present: 'snakker',
          past: 'snakket',
          perfect: 'snakket',
          imperative: 'snakk',
        },
        translations: [],
        synonyms: [],
        antonyms: [],
      },
      {
        text: 'bo',
        lvl: 'A1',
        type: 'verb',
        forms: {
          present: 'bor',
          past: 'bodde',
          perfect: 'bodd',
          imperative: 'bo',
        },
        translations: [],
        synonyms: [],
        antonyms: [],
      },
      {
        text: 'jobbe',
        lvl: 'A1',
        type: 'verb',
        forms: {
          present: 'jobber',
          past: 'jobbet',
          perfect: 'jobbet',
          imperative: 'jobb',
        },
        translations: [],
        synonyms: [],
        antonyms: [],
      },
    ],
  },
  Adverb: {
    Sted: [
      { text: 'hjemme', lvl: 'A1', translations: [], synonyms: [], antonyms: [] },
    ],
    Tid: [
      { text: 'i dag', lvl: 'A1', translations: [], synonyms: [], antonyms: [] },
      { text: 'nå', lvl: 'A1', translations: [], synonyms: [], antonyms: [] },
    ],
  },
  Preposisjon: {
    Sted: [
      { text: 'i Norge', lvl: 'A1', translations: [], synonyms: [], antonyms: [] },
      { text: 'på skolen', lvl: 'A1', translations: [], synonyms: [], antonyms: [] },
    ],
  },
  Adjektiv: {},
  Konjunksjon: {},
  Spørreord: {},
  Tallord: {},
  Partikkel: {},
  Interjeksjon: {},
  Frase: {},
};

export const defaultColors = {
  Pronomen: '#a78bfa',
  Substantiv: '#a78bfa',
  Verb: '#a78bfa',
  Adjektiv: '#a78bfa',
  Preposisjon: '#a78bfa',
  Adverb: '#a78bfa',
  Konjunksjon: '#a78bfa',
  Spørreord: '#a78bfa',
  Tallord: '#a78bfa',
  Partikkel: '#a78bfa',
  Interjeksjon: '#a78bfa',
  Frase: '#a78bfa',
};

export const canonicalCategoryIds = {
  Pronomen: 'Pronomen',
  Substantiv: 'Substantiv',
  Verb: 'Verb',
  Adjektiv: 'Adjektiv',
  Preposisjon: 'Preposisjon',
  Adverb: 'Adverb',
  Konjunksjon: 'Konjunksjon',
  Spørreord: 'Spørreord',
  Tallord: 'Tallord',
  Partikkel: 'Partikkel',
  Interjeksjon: 'Interjeksjon',
  Frase: 'Frase',
};

export const canonicalCategoryAliases = {
  pronomen: 'Pronomen',
  pronoun: 'Pronomen',
  pronouns: 'Pronomen',
  'местоимение': 'Pronomen',
  'местоимения': 'Pronomen',
  substantiv: 'Substantiv',
  noun: 'Substantiv',
  nouns: 'Substantiv',
  'существительное': 'Substantiv',
  'существительные': 'Substantiv',
  'субъект': 'Substantiv',
  'объект': 'Substantiv',
  verb: 'Verb',
  verbs: 'Verb',
  'глагол': 'Verb',
  adverb: 'Adverb',
  adverbs: 'Adverb',
  'наречие': 'Adverb',
  'наречия': 'Adverb',
  adjektiv: 'Adjektiv',
  adjective: 'Adjektiv',
  adjectives: 'Adjektiv',
  'прилагательное': 'Adjektiv',
  'прилагательные': 'Adjektiv',
  preposisjon: 'Preposisjon',
  preposition: 'Preposisjon',
  prepositions: 'Preposisjon',
  'предлог': 'Preposisjon',
  'предлоги': 'Preposisjon',
  konjunksjon: 'Konjunksjon',
  conjunction: 'Konjunksjon',
  conjunctions: 'Konjunksjon',
  'союз': 'Konjunksjon',
  'союзы': 'Konjunksjon',
  'spørreord': 'Spørreord',
  question: 'Spørreord',
  questions: 'Spørreord',
  'вопрос': 'Spørreord',
  'вопросительное слово': 'Spørreord',
  tallord: 'Tallord',
  numeral: 'Tallord',
  numerals: 'Tallord',
  'числительное': 'Tallord',
  partikkel: 'Partikkel',
  particle: 'Partikkel',
  particles: 'Partikkel',
  'частица': 'Partikkel',
  interjeksjon: 'Interjeksjon',
  interjection: 'Interjeksjon',
  interjections: 'Interjeksjon',
  'междометие': 'Interjeksjon',
  frase: 'Frase',
  phrase: 'Frase',
  phrases: 'Frase',
  'фраза': 'Frase',
  'фразы': 'Frase',
};

export const grammarRules = {
  START: ['Pronomen', 'Substantiv', 'Adverb', 'Frase'],
  Pronomen: ['Verb'],
  Substantiv: ['Verb'],
  Adverb: ['Verb'],
  Verb: ['Substantiv', 'Pronomen', 'Preposisjon', 'Adverb', 'Frase', 'END'],
  Preposisjon: ['Substantiv', 'Pronomen', 'Frase'],
};

export const levels = ['A1', 'A2', 'B1', 'B2'];
